import { NodeTilgang } from '../../../models/nodeTilgang';
import { client } from '../../client';
import { SubEntityRequestService } from '../subEntityRequestService';

export default class NodeTilgangService extends SubEntityRequestService<NodeTilgang>
{
    constructor() {
        super('nodeMeny', 'tilgang');
    }
    deaktivere = async (baseId: string, ids: number[]) => client.post<void>(`${this.getBaseRoute(baseId)}/deaktivere`, ids);
}